module.exports = __webpack_public_path__ + "static/media/SearchIcon.c2ad5ddf.svg";